// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3ZiXs","header":"PatientQuestionnaire_header__1rDiL","info":"PatientQuestionnaire_info__1eZ7C"};